import { Inject, Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})

export class PromotedLinksService {
  private readonly promotedLinksBaseApiUrl: string;


  constructor(@Inject('BASE_URL') baseUrl: string, private dataService: DataService) {
    this.promotedLinksBaseApiUrl = `${baseUrl}api/promoted-links`;
  }

  public getPromotedLinks(industry: string) {
    let promotedLinksApiUrl = `${this.promotedLinksBaseApiUrl}/${industry}`;

    return this.dataService.get<any>(promotedLinksApiUrl);
  }
}
